/**
 * @generated SignedSource<<5f8af7dc1a15965afa62be4b1b6e1529>>
 * @relayHash eea67e3828c066fddc0cd6e4d1c0726e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 740aae02886ab44cd9cadad175d955c6d9ee801f157ada455ee22f3fd2c6f510

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessShortcutsAppMemoQuery } from './JiraBusinessShortcutsAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessShortcutsAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "740aae02886ab44cd9cadad175d955c6d9ee801f157ada455ee22f3fd2c6f510",
    "metadata": {},
    "name": "JiraBusinessShortcutsAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
